import { Subscription } from 'rxjs';
// Angular
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, Input, ViewChild, AfterViewInit } from '@angular/core';
import { NavigationEnd, Router ,ActivatedRoute} from '@angular/router';
import { Location } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
// Layout
import { LayoutConfigService, SplashScreenService, TranslationService } from './core/_base/layout';
// language list
import { locale as enLang } from './core/_config/i18n/en';
import { locale as chLang } from './core/_config/i18n/ch';
import { locale as esLang } from './core/_config/i18n/es';
import { locale as jpLang } from './core/_config/i18n/jp';
import { locale as deLang } from './core/_config/i18n/de';
import { locale as frLang } from './core/_config/i18n/fr';
import { filter } from 'rxjs/operators';
import { Title, Meta } from '@angular/platform-browser';
import {environment} from '../environments/environment';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LenderMappingService } from './core/_services';
@Component({
	// tslint:disable-next-line:component-selector
	selector: 'body[kt-root]',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, OnDestroy {
	// Public properties
	title = 'Metronic';
	loader: boolean;
	 @Input() userEmail: string;
	  notifications: { title: string, message: string }[] = [];
	  @ViewChild('content', { static: false }) modalContent: any;
	  private modalRef: NgbModalRef | null = null;
	  private server = 'lms'; // Server identifier
	private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

	/**
	 * Component constructor
	 *
	 * @param translationService: TranslationService
	 * @param router: Router
	 * @param layoutConfigService: LayoutCongifService
	 * @param splashScreenService: SplashScreenService
	 */
	private losbaserl: string = environment.urls.api.los_url;
	constructor(
		private translationService: TranslationService,
		private router: Router,
		private location: Location,
		 // private cookieService: CookieService,
			private modalService: NgbModal,
			private sanitizer: DomSanitizer,
			 private lenderService: LenderMappingService,
			private route1: ActivatedRoute,
		private layoutConfigService: LayoutConfigService,
		private splashScreenService: SplashScreenService,
		private metaService: Meta ) {
			this.losbaserl = environment.urls.api.los_url;
			this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      const path = event.urlAfterRedirects.split('?')[0].split('#')[0];
      if (['/', '/auth/login'].includes(path)) {
        return;
      }
      this.handleNotification();
    });
		// register translations
		this.translationService.loadTranslations(enLang, chLang, esLang, jpLang, deLang, frLang);
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		// tslint:disable
		// this.handleNotification();
		

		// enable/disable loader
		this.loader = this.layoutConfigService.getConfig('loader.enabled');

		const routerSubscription = this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				// hide splash screen
				this.splashScreenService.hide();

				// scroll to top on every route change
				window.scrollTo(0, 0);

				// to display back the body content
				setTimeout(() => {
					document.body.classList.add('kt-page--loaded');
				}, 500);
			}
		});
		this.unsubscribe.push(routerSubscription);
		// tslint:disable-next-line:max-line-length
		// this.metaService.addTag({ 'http-equiv': 'Content-Security-Policy', content: `default-src 'self'; script-src 'self'  ;connect-src 'self' ${environment.BASEPATH} ; media-src  ; style-src 'self' ; frame-src 'self'` });
		// tslint:disable-tab-indentation-expected
	}
    ngAfterViewInit(): void {
		setTimeout(() => {
		  if (this.notifications.length > 0) {
			this.openModal();
		  }
		});
		
	  }
	
	  private filterPayload(payload: any[], cookieData: any[]): any[] {
		const cookieSet = new Set(cookieData.map(item => `${item.server}-${item.id}`));
		return payload.filter(item => 
		  !item.target_apps.some(server => cookieSet.has(`${server}-${item.id}`))
		);
	  }
	
	  private filterPayloadByServer(payload: any[], server: string): any[] {
		return payload.filter(item => item.target_apps.includes(server));
	  }
	  setCookie(name: string, value: string, days: number): void {
		const expires = new Date();
		expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
		document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
	  }
	
	  // ✅ Get Cookie
	  getCookie(name: string): string | null {
		const cookies = document.cookie.split('; ');
		for (let cookie of cookies) {
		  const [cookieName, cookieValue] = cookie.split('=');
		  if (cookieName === name) {
			return cookieValue;
		  }
		}
		return null;
	  }
	  
	  handleNotification(): void {
		let tenantId = null;
		try {
			const userStr = localStorage.getItem('user');
			if (userStr) {
				const user = JSON.parse(userStr);
				if (user && user.org) {
					tenantId = user.org;
				}
			}
		} catch (e) {}

		const headers: any = {
			'Authorization': 'hjghfgdgstrciOiJIUzI1NiIsInR5cCI6z',
			'Content-Type': 'application/json'
		};
		if (tenantId) {
			headers['tenant-id'] = tenantId;
		}

		fetch(`${this.losbaserl}unified/api/notifications/`, {
			method: 'GET',
			headers: headers
		  })
			.then(response => response.json())
			.then((data: any) => {
			  if (data.status === 'success') {
				let payload = data.notifications;
				let user = localStorage.getItem('email_id_raindow') || '';
		
				payload = this.filterPayloadByServer(payload, this.server);
		
				const cookieValue = this.getCookie(user);
				let finalData = cookieValue ? JSON.parse(cookieValue) : [];
		
				payload = this.filterPayload(payload, finalData);
		
				if (payload.length === 0) {
				  return;
				}
		
				let message = [];
		
				payload.forEach(item => {
				  finalData.push({ server: this.server, id: item.id, user });
		
				  // ✅ Inject inline image styles into the HTML content
				  const styledMessage = item.message.replace(
					/<img /g,
					'<img style="max-width:700px;object-fit:contain" '
				  );
		
				  message.push({
					title: item.title,
					message: this.sanitizer.bypassSecurityTrustHtml(styledMessage) as SafeHtml
				  });
				});
		
				if (finalData.length > 0) {
				  this.setCookie(user, JSON.stringify(finalData), 1);
				}
		
				if (message.length > 0) {
				  this.notifications = message;
				  this.openModal();
				}
			  }
			})
			.catch(error => console.error('Error:', error));
	
	  }
	  
	
	  openModal(): void {
		if (this.modalContent) {
		  this.modalRef = this.modalService.open(this.modalContent, { size: 'lg', centered: true });
		} else {
		  console.error('Modal content is not available.');
		}
	  }
	
	  closeModal(): void {
		if (this.modalRef) {
		  this.modalRef.close();
		  this.modalRef = null;
		}
	  }
	/**
	 * On Destroy
	 */
	ngOnDestroy() {
		this.unsubscribe.forEach(sb => sb.unsubscribe());
	}
}
